import React, { useEffect, useState} from "react";
// import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {useSelector} from "react-redux";
import {SuppliersList} from "./SuppliersList";
import {SupplierInfo} from "./SupplierInfo";
import { fetchCompaniesByEmployee } from "./ordersCrud";

function SuppliersPage({ setNewOrder }) {

    const {user,accessToken} = useSelector(
        ({auth}) => ({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )
    
    const [suppliers,setSuppliers] = useState([]);
    const [isSupplierSelected, setIsSupplerSelected] = useState(false)
    const [supplier,setSupplier] = useState({})
    const [isSuppliersFetched, setIsSuppliersFetched] = useState(false)
    const [isCompaniesFetched, setIsCompaniesFetched] = useState(false)
    const [companies,setCompanies] = useState([])

    const handleSupplierChange = (supplier) => {
        setSupplier(supplier);
        setIsSupplerSelected(true)

        fetchCompaniesByEmployee(user.id,accessToken,supplier._id).then(response =>{
            
            setCompanies(response.data)
            setIsCompaniesFetched(true)

        }).catch(err => {
            console.log("Error: ", err)
        })   
    }

    return (
        <>
            {!isSupplierSelected ?(
                <SuppliersList 
                    setSuppliers={setSuppliers}
                    setIsSupplerSelected={setIsSupplerSelected} 
                    handleSupplierChange={handleSupplierChange}
                    setIsSuppliersFetched={setIsSuppliersFetched}
                />
            ):(
                isCompaniesFetched ?
                    <SupplierInfo supplier={supplier} setIsSupplerSelected={setIsSupplerSelected} companies={companies} setNewOrder={setNewOrder}/>
                    :
                    <div className="row justify-content-center mt-20">
                        <span className="ml-3 spinner spinner-lg spinner-primary"></span>
                    </div>
            )}
        </>
    );
}
    
export default injectIntl(SuppliersPage);